module.exports = __webpack_public_path__ + "static/media/icon_delete_time.af937956.svg";